import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'form-action-buttons',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './form-action-btns.component.html',
  styleUrl: './form-action-btns.component.scss'
})
export class FormActionButtonsComponent {
    @Input() justify: 'center' | undefined;
}
